import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import browserHistory from 'components/utility/history';
import { bindActionCreators } from 'redux';
import ModelInfoDialog from '../view/ModelInfoDialog';
import * as actions from '../actions';

/**
 * Query for model creation details and push them into state.
 */
class ModelDesignInitiator extends React.Component {
	constructor(props) {
		super(props);
		this.cancelCreateModel = this.cancelCreateModel.bind(this);
		this.createModel = this.createModel.bind(this);

		this.state = {};
	}

	cancelCreateModel() {
		this.props.actions.designModelCancel();
	}

	createModel(initial) {
		let modelSource = null;
		if (initial.modelSource) {
			if (typeof initial.modelSource === 'string') {
				modelSource = this.props.models[initial.modelSource];
			} else {
				modelSource = initial.modelSource;
			}
		}
		this.props.actions.designModelInitState({
			...this.props.initial,
			...initial,
			modelSource,
			queryState: false
		});

		if (this.props.initial.mode === 'compose') {
			browserHistory.push(`${window.$conf.prefix}/project/models/compose`);
		} else {
			browserHistory.push(`${window.$conf.prefix}/project/models/create`);
		}
	}

	render() {
		const { initial, models, connectors, onOkay, onClose, okayText, closeText } = this.props;
		if (initial && initial.queryState) {
			return (
				<ModelInfoDialog
					mode={initial.mode}
					models={models}
					values={initial}
					connectors={connectors}
					onOkay={onOkay || this.createModel}
					onClose={onClose || this.cancelCreateModel}
					okayText={okayText}
					closeText={closeText}
				/>
			);
		}
		return null;
	}
}

ModelDesignInitiator.propTypes = {
	okayText: PropTypes.string,
	closeText: PropTypes.string,
	onOkay: PropTypes.func,
	onClose: PropTypes.func
};

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}

function mapStateToProps(state) {
	const { initial } = state.models;
	return {
		models: state.models.models || {},
		connectors: state.connectors.connectors,
		initial
	};
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ModelDesignInitiator);
